module.exports = __webpack_public_path__ + "IJF_LongTraining-743f5ec3b164568f33dbab8a215012b8.png";